<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('ApplySettings') }} > {{ $t('VoiceprintRecognition') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('fullName')">
            <el-input v-model="formInline.voiceUserName" clearable :placeholder="$t('fullName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('uploadTimestamp')" class="datetime">
            <el-date-picker v-model="formInline.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true" :placeholder="$t('startDate')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker v-model="formInline.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true" :placeholder="$t('endDate')">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="searchList">{{ $t('query') }}</el-button>
            <el-button type="primary" class="add-btn" @click="addFace">{{ $t('newlyAded') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table 组件 -->
        <Table :data="tableData" :tableHeight="640" :columns="columns" :operation="dateOperation" @operate="operationEvent" :playBtnTime="playBtnTime" :operationWidth="170" @sortChange="handleSort"></Table>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalData">
        </el-pagination>
      </div>
    </div>
    <!-- 新增/编辑 弹窗 -->
    <el-dialog :title="editVoice ? $t('editVoiceprintRecognition') : $t('newVoiceprintRecognition')" :visible.sync="dialogVoice" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
      :append-to-body="true">
      <el-form :model="fromData">
        <div class="settingDialog">
          <el-form-item :label="$t('recordingOwner')" :label-width="formLabelWidth" :required="true">
            <el-input v-model="fromData.voiceUserName" autocomplete="off" :placeholder="$t('pleaseEnter') + $t('fullName')" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('eecordVoice')" :label-width="formLabelWidth" :required="true">
            <el-button type="primary" class="star-radio" v-if="!startRecord && !fromData.voiceUrl" @click="startRecordVoice()">{{ $t('startRecording') }}</el-button>
            <el-button type="primary" class="reset-record" v-if="!startRecord && fromData.voiceUrl" @click="startRecordVoice()">{{ $t('reRecord') }}</el-button>
            <el-button type="primary" v-if="!startRecord && fromData.voiceUrl" @click="playVoice(fromData.voiceUrl)">{{
              $t('playRecording')
            }}</el-button>
            <el-button type="primary" v-if="startRecord" @click="endRecordVoice()">{{
              $t('stopRecordinge')
            }}</el-button>
            <span v-if="startRecord && fromData.voiceUrl" class="recor-time">{{ endTime }}</span>
            <span v-if="startRecord" class="recording">{{ $t('recording') }}<span class="dot">...</span></span>
            <span v-if="playIng" class="recording">{{ $t('playing') }}<span class="dot">...</span></span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="!startRecord && (editVoice || fromData.voiceUrl)" @click="submitFace()">{{
          $t('saveRecording')
        }}</el-button>
        <el-button v-if="!startRecord" @click="quitDialog()">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <audio id="voiceRecognition" muted="true" ref="audio" @canplay="getDuration"></audio>
  </div>
</template>
<script>
import Table from '@/components/table'
import { voiceCreate, voiceDelete, voicePageList, voiceUpdate } from '@/api/voiceRecognit'
import { errorMessage, success } from '@/util/common'
import { errorCollection } from '@/api/dmp/dmpCollection'
import Recorderx, { ENCODE_TYPE } from 'recorderx'
const rc = new Recorderx()
export default {
  data() {
    return {
      formInline: {
        voiceUserName: '',
        startTime: '',
        endTime: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      editVoice: false,
      dialogVoice: false,
      fromData: {
        voiceUserName: '',
        file: '',
        id: '',
      },
      formLabelWidth: '120px',
      data: [],
      fileList: [],
      startRecord: false,
      recordVoice: null,
      endTime: null,
      h: 0, //定义时，分，秒，毫秒并初始化为0；
      m: 0,
      ms: 0,
      s: 0,
      time: 0,
      // 预防提交按钮重复点击
      subRemind: false,
      // 播放声音
      playIng: false,
      // 秒来计算要播放的时间
      playTime: 0,
      clearaudioTime: null,
      playBtnTime: 0,
    }
  },
  components: {
    Table,
  },
  methods: {
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.searchList()
    },
    getDuration() {
      this.playBtnTime = this.$refs.audio.duration
      this.countDown(this.playBtnTime)
    },
    // 播放录制声音
    playVoice(voiceUrl) {
      if (this.recordVoice) {
        voiceUrl = URL.createObjectURL(this.recordVoice)
      }

      let audio = document.getElementById('voiceRecognition')
      audio.src = voiceUrl
      audio.play()
      let resetTime = this.playTime
      this.countDown(resetTime)
      // console.log(this.playTime)
    },
    // 倒计时语音动画
    countDown(resetTime) {
      if (resetTime > 0) {
        resetTime--
        this.playIng = true
        // console.log(resetTime)
        this.clearaudioTime = setTimeout(() => {
          this.countDown(resetTime)
        }, 1000)
      } else {
        clearTimeout(this.clearaudioTime)
        this.playIng = false
        this.playBtnTime = 0
      }
    },
    timer() {
      //定义计时函数
      this.ms = this.ms + 500 // 毫秒
      if (this.ms >= 1000) {
        this.ms = 0
        this.s = this.s + 1 // 秒
        this.playTime = this.playTime + 1 // 秒
      }
      if (this.s >= 60) {
        this.s = 0
        this.m = this.m + 1 // 分钟
      }
      if (this.m >= 60) {
        this.m = 0
        this.h = this.h + 1 // 小时
      }

      this.endTime =
        this.toDub(this.h) + ':' + this.toDub(this.m) + ':' + this.toDub(this.s) + '' /*+this.toDubms(this.ms)+"毫秒"*/
    },
    toDub(n) {
      //补0操作
      if (n < 10) {
        return '0' + n
      } else {
        return '' + n
      }
    },
    // 开始录制声音
    startRecordVoice() {
      // 重置时间
      clearInterval(this.time)
      this.h = 0
      this.m = 0
      this.ms = 0
      this.s = 0
      this.endTime = '00:00:00'
      this.playTime = 0
      this.playIng = false
      this.time = setInterval(this.timer, 500)
      let audio = document.getElementById('voiceRecognition')
      audio.pause()
      let that = this
      rc.start()
        .then(() => {
          that.startRecord = true
          console.log('start recording')
        })
        .catch((error) => {
          that.startRecord = false
          this.$message({
            type: 'error',
            message: this.$t('FailedAcquireMicrophone'),
            customClass: 'zZindex',
            duration: 2000,
          })
          errorCollection('声纹识别', '获取麦克风权限', { status: 200, data: { state: -1, msg: '获取麦克风失败!' } })
          console.log('Recording failed.', error)
        })
    },
    // 结束录制声音
    endRecordVoice() {
      clearInterval(this.time)
      rc.pause()
      this.recordVoice = rc.getRecord({
        encodeTo: ENCODE_TYPE.WAV,
        compressible: true,
      })
      rc.clear()
      this.fromData.voiceUrl = 'show'
      this.startRecord = false
    },
    // 提交 新增/ 编辑的内容
    submitFace() {
      this.playIng = false
      if (this.subRemind === true) return
      if (this.subRemind === false) {
        this.subRemind = true
        setTimeout(() => {
          this.subRemind = false
        }, 2000)
      }
      let audio = document.getElementById('voiceRecognition')
      audio.pause()
      // 判断表单是否填入内容 提示
      if (!this.fromData.voiceUserName) {
        errorCollection('声纹识别', '新增/编辑声纹识别数据', { status: 200, data: { state: -1, msg: '请输入姓名' } })
        errorMessage(this.$t('pleaseEnter') + this.$t('fullName'))
        return
      } else if (!this.editVoice && !this.recordVoice) {
        errorCollection('声纹识别', '新增/编辑声纹识别数据', { status: 200, data: { state: -1, msg: '请录制语音' } })
        errorMessage(this.$t('pleaseRecordVoice'))
        return
      } else {
        // 通过 FormData 对象上传文件
        let formData = new FormData()
        if (this.recordVoice) {
          let fileName = new Date().getTime() + (Math.floor(Math.random() * 10) + 1) + '.wav'
          formData.append('file', this.recordVoice, fileName)
        } else {
          formData.append('file', null)
        }
        formData.append('voiceUserName', this.fromData.voiceUserName)
        if (!this.editVoice) {
          this.creatVoice(formData)
        } else {
          // 提交完成编辑
          formData.append('id', this.fromData.id)
          this.voiceUpdate(formData)
        }
      }
    },
    // 取消窗口
    quitDialog() {
      this.dialogVoice = false
      this.recordVoice = null
      this.playIng = false
      this.endTime = null
    },
    creatVoice(param) {
      // 输入完成后请求 添加 接口
      voiceCreate(param).then((res) => {
        if (res.state === 0) {
          if (res.data && res.data.id != -1) {
            this.dialogVoice = false
            this.recordVoice = null
            this.basicConfig()

            success(this.$t('AddSuccess'))
          } else {
            errorMessage(this.$t('user') + '【' + res.data.voiceUserName + '】' + this.$t('recordingWithTheSame'))
          }
        }
      })
    },
    voiceUpdate(param) {
      voiceUpdate(param).then((res) => {
        if (res.state === 0) {
          if (res.data && res.data.id != -1) {
            this.dialogVoice = false
            this.recordVoice = null
            this.basicConfig()
            this.subRemind = false
            success(this.$t('EditSucceeded'))
          } else {
            errorMessage(this.$t('user') + '【' + res.data.voiceUserName + '】' + this.$t('recordingWithTheSame'))
          }
        }
      })
    },
    // 点击新增按钮
    addFace() {
      // 清空 from表单
      this.fromData = {
        voiceUserName: '',
        file: '',
        id: '',
      }
      // 区别弹窗 true：新增 false：编辑
      this.editVoice = false
      // 显示弹窗
      this.dialogVoice = true
      clearInterval(this.time)
      this.h = 0
      this.m = 0
      this.ms = 0
      this.s = 0
    },
    // table 的按钮操作
    operationEvent(type, value, index) {
      let audio = document.getElementById('voiceRecognition')
      audio.pause()
      this.endTime = null
      this.playIng = false
      clearInterval(this.time)
      this.h = 0
      this.m = 0
      this.ms = 0
      this.s = 0
      clearTimeout(this.clearaudioTime)
      if (type.type === 'edit') {
        this.editFaceInfo(type.value)
      } else if (type.type === 'delete') {
        this.deleteInfo(type.value)
      } else if (type.type === 'play') {
        this.playVoice(type.value.voiceUrl)
      }
    },
    // 编辑其中一条信息
    editFaceInfo(row) {
      // 回显数据
      this.fromData = Object.assign({}, row)
      this.editVoice = true
      this.dialogVoice = true
    },
    // 删除信息
    deleteInfo(row) {
      this.$confirm(this.$t('deleteThisInformation'), '提示', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = { id: BigInt(row.id) }
        voiceDelete(param).then((res) => {
          if (res.state === 0) {
            success(this.$t('DeletionSucceeded'))
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.basicConfig()
    },
    // 根据条件进行查询
    searchList() {
      this.currentPage = 1
      this.basicConfig()
    },
    // 基础配置信息，请求table数据
    basicConfig() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        voiceUserName: this.formInline.voiceUserName,
        startTime: this.formInline.startTime,
        endTime: this.formInline.endTime,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      voicePageList(param).then((res) => {
        if (res.state === 0) {
          this.tableData = res.value.content
          this.totalData = res.value.totalElements
        }
      })
      // table header
      this.columns = [
        {
          attrName: 'voiceUserName',
          label: this.$t('recordingOwner'),
          sort: 'voiceUserName',
        },
        {
          attrName: 'uploadUserName',
          label: this.$t('uploadUser'),
          sort: 'uploadUserName',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('uploadTimestamp'),
          align: 'center',
          width: '180',
          sort: 'logTimestamp',
        },
      ]
      // 操作
      this.dateOperation = [
        {
          operateName: this.$t('play'),
          type: 'play',
          IsHad: '',
          class: 'editClick',
          playicon: require('@/icon/vioce.png'),
        },
        {
          operateName: this.$t('edit'),
          type: 'edit',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delete',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
  },
  computed: {
    myHeader() {
      return {
        authToken: window.sessionStorage.getItem('access_token'),
      }
    },
  },
  created() {
    this.basicConfig()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';

.tip {
  display: block;
  font-size: 12px;
  line-height: 18px; /* no */
  color: red;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .upload-txt {
    text-align: center;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 100px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  display: block;
}

.star-radio {
  margin-right: 20px;
}

.reset-record {
  margin-right: 14px;
}

.recording {
  margin-left: 5px;
}

.search {
  .el-form {
    .el-date-editor {
      width: 180px !important; /* no */
    }
  }
}

.dot {
  font-family: simsun;
  animation: dot 2s infinite step-start;
}

@keyframes dot {
  0% {
    width: 0;
    margin-right: 1.5em;
  }

  33% {
    width: 0.5em;
    margin-right: 1em;
  }

  66% {
    width: 1em;
    margin-right: 0.5em;
  }

  100% {
    width: 1.5em;
    margin-right: 0;
  }
}

:root .dot {
  display: inline-block;
  width: 1.5em;
  vertical-align: bottom;
  overflow: hidden;
}

.recor-time {
  margin: 0 10px;
}

.bg-contain .common-table-cnt /deep/ .el-table {
  height: 635px !important;
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}

>>> .el-input__inner {
  background-color: var(--bg-white) !important;
  border: 1px solid var(--new-input-focus-border) !important;
}
</style>
